import Form from 'react-bootstrap/Form';
import { Field } from 'formik';
import { camelToHuman } from '../util/changeCase';

let ValidationOptionsInput = ({
  name,
  options,
  label,
  allowBlank = false,
  noMargin = false,
  className,
  ...props
}) => {
  let showLabel = label !== '';
  let optionsKeyed = [];
  if (Array.isArray(options)) {
    optionsKeyed = options.map((option) => ({ name: option, value: option }));
  } else {
    optionsKeyed = Object.entries(options).map(([value, name]) => ({ name, value }));
  }
  return (
    <Field name={name}>
      {({ field, form: { touched, errors } }) => {
        let modified = touched[name];
        let error = errors[name];
        return (
          <Form.Group className={(noMargin ? 'mb-0' : '') + ' ' + (className ?? '')}>
            {showLabel && <Form.Label className="mb-0">{label || camelToHuman(name)}</Form.Label>}{' '}
            <Form.Control
              {...props}
              {...field}
              data-cy={`input-${name}`}
              as="select"
              className="form-select"
              isInvalid={!!error && modified}
            >
              {allowBlank && <option value="" />}
              {optionsKeyed.map(({ name, value }) => (
                <option value={value} key={value}>
                  {name}
                </option>
              ))}
            </Form.Control>
            {modified && error && <p className="text-danger">{error}</p>}
          </Form.Group>
        );
      }}
    </Field>
  );
};

export default ValidationOptionsInput;
